module.exports = __webpack_public_path__ + "media/images/posts/digital_invitation-b93aaa51ed74d3f51f112373cf75a4b0.jpg";